import Typography from '@/common/components/base/typography/Typography';
import { Flex } from 'styled-system/jsx';
import ArrowLeftIcon from '../../assets/icons/walletArrowLeft.svg?react';

export default function WalletDetailLink({ text }: { text: string }) {
  return (
    <Flex alignItems={'center'} gap={4} height={32} flexShrink={0}>
      <Typography fontSize={12} lineHeight={'24px'} color={'purple-primary'}>
        {text}
      </Typography>
      <ArrowLeftIcon />
    </Flex>
  );
}
